export function getOrCreateClientId(): string {
  try {
    const key = "prewarmClientId";
    let id = localStorage.getItem(key);
    if (!id) {
      id = `c_${Math.random().toString(36).slice(2)}_${Date.now().toString(36)}`;
      localStorage.setItem(key, id);
    }
    return id;
  } catch {
    return "anonymous";
  }
}
